import { render, staticRenderFns } from "./AlsokPanel.vue?vue&type=template&id=d6b43c0a&scoped=true"
import script from "./AlsokPanel.vue?vue&type=script&lang=js"
export * from "./AlsokPanel.vue?vue&type=script&lang=js"
import style0 from "./AlsokPanel.vue?vue&type=style&index=0&id=d6b43c0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b43c0a",
  null
  
)

export default component.exports